export const messages = {
  en: {
    carMonthCardConfig: {
      title: 'Monthly Card Pricing',
      add: 'Add Monthly Card',
      edit: 'Edit Monthly Card',
      search: {
        cardName: 'Monthly Card Name'
      },
      table: {
        cardName: 'Monthly Card Name',
        cardMonth: 'Duration (Months)',
        cardPrice: 'Price (Yuan)',
        sortNo: 'Sort',
        operation: 'Operation'
      },
      form: {
        cardName: 'Monthly Card Name',
        cardMonth: 'Duration (Months)',
        cardPrice: 'Price (Yuan)',
        sortNo: 'Sort',
        remark: 'Remark'
      },
      placeholders: {
        cardName: 'Required, please enter monthly card name',
        cardMonth: 'Required, please enter duration in months',
        cardPrice: 'Required, please enter price',
        sortNo: 'Optional, smaller number comes first',
        remark: 'Optional, please enter remark'
      },
      rules: {
        cardNameRequired: 'Monthly card name is required',
        cardMonthRequired: 'Duration is required',
        cardPriceRequired: 'Price is required'
      },
      buttons: {
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      errors: {
        listFailed: 'Failed to query monthly card configuration',
        saveFailed: 'Failed to save monthly card configuration',
        deleteFailed: 'Failed to delete monthly card configuration'
      },
      tips: {
        communityScope: 'Monthly cards are priced per community. Only cards in the current community are shown.'
      },
      page: {
        subtitle: 'Maintain the monthly parking card templates available for purchase',
        empty: 'No monthly cards configured',
        loadFailed: 'Monthly card data failed to load, please retry'
      }
    }
  },
  zh: {
    carMonthCardConfig: {
      title: '月卡价格配置',
      add: '新增月卡',
      edit: '修改月卡',
      search: {
        cardName: '月卡名称'
      },
      table: {
        cardName: '月卡名称',
        cardMonth: '时长（月）',
        cardPrice: '价格（元）',
        sortNo: '排序',
        operation: '操作'
      },
      form: {
        cardName: '月卡名称',
        cardMonth: '时长（月）',
        cardPrice: '价格（元）',
        sortNo: '排序',
        remark: '备注'
      },
      placeholders: {
        cardName: '必填，请填写月卡名称',
        cardMonth: '必填，请填写月卡时长',
        cardPrice: '必填，请填写月卡价格',
        sortNo: '选填，数字越小越靠前',
        remark: '选填，请填写备注'
      },
      rules: {
        cardNameRequired: '月卡名称不能为空',
        cardMonthRequired: '月卡时长不能为空',
        cardPriceRequired: '月卡价格不能为空'
      },
      buttons: {
        add: '新增',
        edit: '修改',
        delete: '删除',
        cancel: '取消',
        confirm: '确定'
      },
      errors: {
        listFailed: '查询月卡配置失败',
        saveFailed: '保存月卡配置失败',
        deleteFailed: '删除月卡配置失败'
      },
      tips: {
        communityScope: '月卡按小区定价，页面只显示当前小区的月卡。'
      },
      page: {
        subtitle: '维护可购买的车位月卡模板',
        empty: '暂无月卡配置',
        loadFailed: '月卡数据加载失败，请重试'
      }
    }
  }
}
